export default __webpack_public_path__ + "static/media/reward-reciever-2.9963d767.png";